// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2htXG","content":"styles_content__18MGF"};